import * as React from "react";
import { logToAndylitics } from "../../api/andyliticsApi";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

export default class MyChartActivation extends React.Component {

    componentDidMount() {
        logUI("MBHWeb.UI.MyChartActivation.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    logActivity(activityPath, url) {
        logToAndylitics(activityPath, new Date(), url);
    }

    render() {
        const { myChartLinkUrl, myChartActivationUrl } = this.props;
        return (
            <div className="card thrive-activate-mychart">
                <div className="card-header">
                    <div className="row">
                        <div className="col-12">
                            <div className="card-heading">Baylor Scott & White employees, it’s that time again.</div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <p>
                                Use the activation code received from your clinic to activate your MyChart account.&nbsp;
                            </p>
                            <p>
                                Once MyChart is activated, you'll have access to submit a health screening.&nbsp;
                                Already have a MyChart account? &nbsp;
                                <br />
                                <a className="link-style" href={myChartLinkUrl} onClick={() => this.logActivity('MBHWeb.Thrive.LinkMyChart.Redirect', myChartLinkUrl)}>
                                    Link it here
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="card-footer">
                    <div className="row">
                        <div className="col-12">
                            <a className="btn btn-primary" href={myChartActivationUrl} target="_blank"
                                onClick={() => this.logActivity('MBHWeb.Thrive.ActivateMyChart.Redirect', myChartActivationUrl)}
                            >Activate MyChart</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}